import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Match } from '../../models/match';
import { GamificationResult } from '../../models/gamification';
import { BadgesHttpService } from './badges.httpservice';
import { GamificationCelebrationComponent } from '../components/gamification-celebration/gamification-celebration.component';

@Injectable({
	providedIn: 'root'
})
export class GamificationCelebrationService {

	constructor(private modalCtrl: ModalController, private badgesHttpService: BadgesHttpService) {

	}

	// match is optional: when given, the modal offers to share a recap card of it.
	celebrate(result: GamificationResult | null | undefined, match?: Match): void {
		if (!result) {
			return;
		}
		// With a match there is a rating change to show and a result to share, like the casual match alert.
		const hasRatingMoment = !!match && result.ratingDelta != null;
		if (!hasRatingMoment && !result.leveledUp && (!result.unlockedBadges || result.unlockedBadges.length === 0)) {
			return;
		}

		this.modalCtrl.create({
			component: GamificationCelebrationComponent,
			cssClass: 'gamification-celebration-modal',
			showBackdrop: false,
			componentProps: { result, match }
		}).then(modal => modal.present());
	}

	// On app open/resume: what an opponent's or organiser's recorded result earned this user since they last looked.
	showUnseen(): void {
		this.badgesHttpService.claimCelebration().subscribe({
			next: result => this.celebrate(result),
			error: () => { /* nothing to show; it stays unseen for the next open */ }
		});
	}
}
